// Entry switch (#86bcd131r): a URL whose hash is a route ("#/...") opens the new UI
// (src/modern/); any other URL opens classic exactly as before (src/classicMain.js holds the
// old entry, moved verbatim). The two never load together: crossing between them reloads.
// No way into the new UI for end users until it is ready (#86bcp2tqv, David 2026-10-21): the bare "/" opens classic on
// every device, and a home-screen launch, the old start address "/?source=homescreen#/" included, is classic's
// address first (src/homeScreen.js). Only a full new-UI address ("/#/login", "/#/demo", the demo icon's marked
// "/?source=homescreen#/demo") opens the new UI.
import { homeScreenLaunch } from './homeScreen'
import { reloadWhenRestored } from './pageRestore'

// Either app's page brought back from the back-forward cache loads again, so a Logout in this tab ends it too
// (src/pageRestore.js; W3 security review finding 2).
window.addEventListener('pageshow', reloadWhenRestored)

// A home-screen launch is classic's, unless it starts at a full new-UI address (ADR-007 Amendment 1).
const launch = homeScreenLaunch(window.location)
try {
  if (launch) window.history.replaceState(window.history.state, '', launch)
} catch (error) {
  console.error(error) // never a blank page: the app below still starts
}

const isModern = () => window.location.hash.startsWith('#/')
const modern = isModern()
// The sandbox (#86bcjqw6j, /#/demo; the same rule as src/modern/sandbox/mode.js) is the new UI on this device's own
// data: crossing into or out of it reloads too, so a page is the sandbox or the real app for its whole life. The
// address's popstate stops here, before the router's listener (this one is the page's first): neither app's router ever
// draws the other's address (the sandbox's has no /login; the real app's would send /demo home).
const isDemo = () => /^#\/demo(?:[/?]|$)/.test(window.location.hash)
const demo = isDemo()
let leaving = false
const leave = () => {
  if (leaving) return
  leaving = true
  window.location.reload()
}
window.addEventListener('popstate', (event) => {
  if (isDemo() === demo) return
  event.stopImmediatePropagation()
  leave()
})
window.addEventListener('hashchange', () => {
  if (isModern() !== modern || isDemo() !== demo) leave()
})

// A chunk that can't load (offline, or a deploy replaced it) would otherwise leave a blank page.
const showLoadError = (error) => {
  console.error(error)
  const root = document.getElementById('root')
  const retry = document.createElement('button')
  retry.textContent = 'Try again'
  retry.onclick = () => window.location.reload()
  root.replaceChildren('Cannot reach ScaleWatcher Cloud. ', retry)
}

if (modern) {
  import('./modern/main').then((m) => m.mount(document.getElementById('root'))).catch(showLoadError)
} else {
  import('./classicMain').catch(showLoadError)
}
